import React from 'react';
import PropTypes from 'prop-types';

const TabContainer = props => {
  return (
    <div {...props}>
      {props.children}
    </div>
  );
};

export class SwipeableTab extends React.PureComponent {
  static propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    tabComponent: PropTypes.node,
    tabProps: PropTypes.object,
    containerProps: PropTypes.object
  }

  static defaultProps = {
    label: '',
    tabProps: {},
    containerProps: {}
  }

  render() {
    const {containerProps} = this.props;

    return (
      <TabContainer {...containerProps}>
        {this.props.children}
      </TabContainer>
    );
  }
}

export default SwipeableTab;
